/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Basic_Included1Inputs */

const ja_playdata_pricing_basic_included1 = /** @type {(inputs: Playdata_Pricing_Basic_Included1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会3日分の統計`)
};

const en_playdata_pricing_basic_included1 = /** @type {(inputs: Playdata_Pricing_Basic_Included1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 streaming days included`)
};

/**
* | output |
* | --- |
* | "3 streaming days included" |
*
* @param {Playdata_Pricing_Basic_Included1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_basic_included1 = /** @type {((inputs?: Playdata_Pricing_Basic_Included1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Basic_Included1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_basic_included1(inputs)
	return en_playdata_pricing_basic_included1(inputs)
});